import React, { Component } from "react";
import logo from "../../../../assets/img/logo.svg";
import { QRCode } from "react-qrcode-logo";
import ReactToPrint from "react-to-print";
import "./DispatchLabel.css";
class DispatchLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelData: props.BookingDetails || false,
    };
  }

  render() {
    const wid = "80mm";
    const hig = "30mm";
    const InvoiceCss = `
  @page {
    size : ${wid}  auto ;
    margin : 1px;   
    font-family: Arial, sans-serif;
  } 

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
 .label{
    width : ${wid};
    height: cal(${hig}-1mm);    
    font-size: 13px; 
    font-weight:400; 
  }
  br,ul,p{
  padding:0px;
  margin:0px;
} 
.label_header{ 
  list-style-type: none; 
  padding:0px;
  display:flex;
  align-items:center;
}
.label_header li{ 
  display:inline-block;
  padding-right:5px;
}
.label_header li:last{  
  padding-right:10px;
}
p,b { 
 
} 
address > p
{
  padding:1px 0px 1px 0px;
}
.logo img
{ 
  width:11mm;
  height:8mm; 
}
.bold{ 
  font-weight:800;
  font-style:none;
}
.qrLogo
{ 
  display:block;
  content-align:"text-center";
  padding:0px; 
  position:fixed;
}
.qrLogo img, .qrLogo canvas  {
  width:25mm !important;
  height:25mm  !important;
} 
.qrLogo p {
  text-align:center;
  margin-top:-0px;
}
.right{ 
  float:right;
  position:relative; 
  top: -105px;
  right: 105px;
}
footer{
  bottom:0px;
  left:0px;
}
.label_details {
  list-style-type: none;
  padding: 3px; 
  align-items: center;
}
.label_details li{
  padding:1px 0px 0px 0px;
}
`;
    return (
      <div className="card-body">
        <ReactToPrint
          documentTitle={"Print Dispatch Label"}
          pageStyle={InvoiceCss}
          copyStyles={false}
          trigger={() => {
            return (
              <button className="col w-100 btn btn-warning btn-multiline btn btn-w-lg align-self-center">
                <span className="material-icons-outlined fs-35">print</span>
              </button>
            );
          }}
          content={() => this.componentRef}
        />
        <LabelLayout
          ref={(el) => (this.componentRef = el)}
          labelData={this.state.labelData}
        />
      </div>
    );
  }
}

export const LabelLayout = React.forwardRef((props, ref) => {
  const bookingData = props.labelData;
  return (
    <div className="label" ref={ref}>
      <div className="left">
        <ul className="label_header">
          {/* <li className="logo">
            <img src={logo} alt="logo" width="11" /> */}
          {/* {logo} */}
          {/* </li> */}
          <li className="bold"> Order Details</li>
          <li> {bookingData.id}</li>
          <li> {bookingData.message}</li>
        </ul>
        <ul className="label_details">
          <li className="bold">Address:. {bookingData.address}</li>
          <li>
            Landmark:. {bookingData.landmark}
            <small> {bookingData.date}</small>
          </li>
          <li className="bold">
            Contact:.{" "}
            {bookingData.customer !== bookingData.contact
              ? `${bookingData.customer} ${bookingData.contact}`
              : `${bookingData.customer}`}
          </li>
          <li>
            Items:. {bookingData.total_items}{" "}
            <span className="bold">Total:. {bookingData.total_amount}</span>
          </li>
          <li>
            Advance:. {bookingData.advance_amount} Delivery:.{" "}
            {bookingData.delivery_charger}
          </li>
          <li className="bold">Balance Amount: {bookingData.balance_amount}</li>
          <li>Remark:. {bookingData.remark}</li>
        </ul>
      </div>
      {/* <div className="right">
        <div className="qrLogo">
          <QRCode
            value={
              "000201010211153137910524005204462009150148:145326390011fonepay.com0110200915014802061453745204539953035245802NP5920NARAYANI BAKERY CAFE6007Nuwakot62350706145374021098401817600807Payment63048719"
            }
            size="2000"
            alt={"Scan & Pay"}
            qrStyle="squares"
            logoWidth={100}
            logoHeight={100}
            eyeRadius={2}
            ecLevel="Q"
          />
          <p> Scan &amp; Pay</p>
        </div>
      </div> */}
    </div>
  );
});
export default DispatchLabel;
